const truncateStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px 2px'
  };
  
  export const tableColumns = [
    {
      name: 'Course ID',
      selector: row => row.course_id,
      sortable: true,
      center: true,
      width: '120px',
      style: truncateStyle,
    },
    {
      name: 'Course Name',
      selector: row => row.title,
      sortable: true,
      center: true,
      width: '200px',
      cell: row => (
        <div style={{ 
          ...truncateStyle,
          color: '#5C61F2', 
          fontWeight: 'bold',
          width: '100%',
          textAlign: 'center'
        }}>
          {row.title}
        </div>
      ),
    },
    {
      name: 'Category',
      selector: row => row.category,
      sortable: true,
      center: true,
      width: '230px',
      style: truncateStyle,
    },
    {
      name: 'Created Date',
      selector: row => row.created_date,
      sortable: true,
      center: true,
      width: '140px',
      style: truncateStyle,
    },
    {
      name: 'Course Type',
      selector: row => row.course_type,
      sortable: true,
      center: true,
      width: '140px',
      style: truncateStyle,
    },
    {
      name: 'Status',
      selector: row => row.status_component,
      sortable: true,
      center: true,
      width: '100px',
      id: 'status',
      style: truncateStyle,
    },
    {
      name: 'Action',
      selector: row => row.action,
      sortable: false,
      center: true,
      width: '190px',
      id: 'action',
      style: truncateStyle,
    }
  ];